module.exports = __webpack_public_path__ + "static/Troy.f2756a79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Troy.jpg
// module id = 1328
// module chunks = 137408898365125